// Angular
import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
// Components
import {BaseComponent} from './views/theme/base/base.component';
import {ErrorPageComponent} from './views/theme/content/error-page/error-page.component';
// Auth
import {AuthGuard} from './core/auth';
import { MyPageComponent } from './views/pages/my-page/my-page.component';

const routes: Routes = [
	{path: 'auth', loadChildren: () => import('app/views/pages/auth/auth.module').then(m => m.AuthModule)},
	{path: 'print', loadChildren: () => import('app/views/pages/print/print.module').then(m => m.PrintModule)},
	{path: 'shoplineitau', loadChildren: () => import('app/views/pages/shopline-itau/shopline-itau.module').then(m => m.ShoplineItauModule)},
	{
		path: '',
		component: BaseComponent,
		canActivate: [AuthGuard],
		children: [
			{
				path: 'dashboard',
				loadChildren: () => import('app/views/pages/dashboard/dashboard.module').then(m => m.DashboardModule),
			},
			{
				path: 'customers',
				loadChildren: () => import('app/views/pages/customers/customers.module').then(m => m.CustomersModule),
			},
			{
				path: 'admin',
				loadChildren: () => import('app/views/pages/admin/admin.module').then(m => m.AdminModule),
			  	canActivate: [AuthGuard],
  				data: { requiredGrant: 'administrator' }
			},
			
			{
				path: 'builder',
				loadChildren: () => import('app/views/theme/content/builder/builder.module').then(m => m.BuilderModule)
			},
			{
				path: 'my-page', // <= Page URL
				component: MyPageComponent // <= Page component registration
			  },
			  
			{
				path: 'error/403',
				component: ErrorPageComponent,
				data: {
					type: 'error-v6',
					code: 403,
					title: '403... Access forbidden',
					desc: 'Looks like you don\'t have permission to access for requested page.<br> Please, contact administrator',
				},
			},
			{path: 'error/:type', component: ErrorPageComponent},
			{path: '', redirectTo: 'customers', pathMatch: 'full'},
			{path: '**', redirectTo: 'customers', pathMatch: 'full'},
		],
	
	},
	{path: '**', redirectTo: 'error/403', pathMatch: 'full'},
];

@NgModule({
	imports: [
		RouterModule.forRoot(routes),//, { relativeLinkResolution: 'legacy' }
	],
	exports: [RouterModule],
})
export class AppRoutingModule {
}
